<template>
  <div class="skill" v-hide="{ hide: !!skill.removed }" @hideComplete="hideComplete">
    <div class="skill__label">
      <div class="skill__grip">
        <FontAwesomeIcon icon="fa-light fa-grip-lines-vertical" />
      </div>
      <div>
        <div>
          <span class="skill__code" v-if="skill.code">{{ skill.code }}</span>
          {{ skill.name }}
        </div>
        <div class="skill__badges" v-if="isBadge">
          <TrainingRncpSourceDetailsComponent :object="skill" @showDetails="showDetails" />
          <span class="badge bg-success" v-if="skill.jobOfferCount"
            >{{ skill.jobOfferCount }} {{ $t("training.rncp.badge.job_offer") }}</span
          >
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center">
      <div class="skill__actions">
        <button
          class="btn-icon btnEdit me-2"
          @click="edit"
          v-tooltip="{
            title: stringManager().globalTranslation('add', 'skill', 'studea_manager', 1, true),
          }"
        >
          <FontAwesomeIcon icon="fa-light fa-pen" />
        </button>
        <button
          class="btn-icon btnRemove"
          @click="remove"
          v-tooltip="{
            title: stringManager().globalTranslation('delete', 'skill', 'studea_manager', 1, true),
          }"
        >
          <FontAwesomeIcon icon="fa-light fa-trash" />
        </button>
      </div>
    </div>
    <BlockLoader size="small" :loading="loading || skill.loading" />
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { trainingManager } from "@/services/training/training-manager";
import BlockLoader from "@/components/blocks/BlockLoader.vue";
import { trainingSkillConstante } from "@/constantes/trainingSkill";
import { stringManager } from "@/services/utilities/string-manager";
import TrainingRncpSourceDetailsComponent from "@/components/training/rncp/TrainingRncpSourceDetailsComponent.vue";

export default {
  name: "TrainingSkillSkillComponent",
  components: { TrainingRncpSourceDetailsComponent, BlockLoader, FontAwesomeIcon },
  emits: ["editSkill", "removed", "hideComplete", "showDetails"],
  props: {
    skill: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    isRncp() {
      return this.skill.origin === trainingSkillConstante.SKILL_ORIGIN_RNCP;
    },

    isBadge() {
      return this.hasSourceDetails || this.skill.jobOfferCount > 0;
    },

    hasSourceDetails() {
      return this.skill.sourceDetails && Object.keys(this.skill.sourceDetails);
    },
  },
  methods: {
    stringManager() {
      return stringManager;
    },

    edit() {
      this.$emit("editSkill", { skill: this.skill });
    },

    async remove() {
      this.loading = true;
      const done = await trainingManager.remove(this.skill.id, this.$route.params.trainingId, "skill", "skill");
      if (done && done.success) {
        this.$emit("removed", this.skill);
      }
      this.loading = false;
    },

    showDetails() {
      this.$emit("showDetails", { object: this.skill, type: trainingSkillConstante.OBJECT_TYPE_SKILL });
    },

    hideComplete() {
      this.$emit("hideComplete", this.skill);
    },
  },
};
</script>

<style lang="scss" scoped>
.skill {
  background: $lighter-grey;
  color: var(--primary-color);
  padding: 15px 20px;
  border-radius: $radius;
  border-left: 4px solid $green;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;

  @include dark-theme {
    color: $white;
  }

  @include up-to-md {
    padding: 15px 10px;
    flex-direction: column;
    align-items: flex-start;
  }

  &__label {
    display: flex;
    align-items: center;
  }

  &__code {
    font-weight: 700;
    margin-right: 8px;
  }

  &__actions {
    margin-left: 18px;
    min-width: 60px;

    @include up-to-md {
      margin-top: 10px;
    }
  }

  &__badges {
    margin-top: 10px;
    .badge + .badge {
      margin-left: 5px;
    }
  }

  &__grip {
    min-width: 20px;
    width: 20px;
    cursor: grab;
    margin-right: 8px;

    @include up-to-md {
      width: 15px;
      margin-right: 0;
    }
  }
}

.skill + .skill {
  margin-top: 20px;
}
</style>
